// Url is deprecated. eventually the frontend will support multiple links
export const getPrimaryUrl = (entity) => entity?.links?.[0]?.url || entity?.url;
